"use client";

import { type ComponentProps, useState } from "react";
import DemoFooter from "@/components/preview/demo-footer";
import DemoSplit from "@/components/preview/demo-split";
import DemoWrapper from "@/components/preview/demo-wrapper";
import ResultPanel from "@/components/preview/result-panel";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import "./interruptible-rotation.css";

type InterruptibleRotationDemoProps = Pick<
  ComponentProps<typeof DemoWrapper>,
  "captionText" | "height" | "margin"
> & { badge?: boolean };

const TIP_CLASS =
  "relative flex size-20 items-center justify-center rounded-2xl bg-sky-400 outline outline-black/10 -outline-offset-1";

export default function InterruptibleRotationDemo({
  badge,
  ...props
}: InterruptibleRotationDemoProps) {
  const [toggled, setToggled] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);

  let animationClass = "";
  if (hasInteracted) {
    animationClass = toggled ? "tip-rotate-forward" : "tip-rotate-backward";
  }

  return (
    <DemoWrapper {...props}>
      <DemoSplit className="min-h-0 flex-1" stackBelow="sm">
        <ResultPanel
          bad
          innerClassName="py-6 sm:py-16"
          label={badge ? undefined : "Keyframe"}
        >
          <div className={cn(TIP_CLASS, animationClass)}>
            <div className="absolute top-2 right-2 size-4 rounded-full bg-white" />
          </div>
        </ResultPanel>

        <ResultPanel
          innerClassName="py-6 sm:py-16"
          label={badge ? undefined : "Transition"}
        >
          <div
            className={cn(TIP_CLASS, "tip-rotate-transition")}
            data-toggled={toggled}
          >
            <div className="absolute top-2 right-2 size-4 rounded-full bg-white" />
          </div>
        </ResultPanel>
      </DemoSplit>
      <DemoFooter>
        <Button
          onClick={() => {
            setHasInteracted(true);
            setToggled((prev) => !prev);
          }}
          size="sm"
          variant="secondary"
        >
          Rotate
        </Button>
      </DemoFooter>
    </DemoWrapper>
  );
}
